/* ============================================================
   DEAD FLIGHT ARROWS — dfa-panier.js
   Mises à jour de lignes via /cart/change.js + re-rendu de la
   section (Section Rendering API). Compteur d'entête synchronisé.
   ============================================================ */
(function () {
  'use strict';

  class DfaPanier extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this._surChangement = this.surChangement.bind(this);
      this._surClic = this.surClic.bind(this);
      this.addEventListener('change', this._surChangement);
      this.addEventListener('click', this._surClic);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this._surChangement);
      this.removeEventListener('click', this._surClic);
    }

    surChangement(e) {
      var champ = e.target.closest('[data-dfa-ligne-quantite]');
      if (!champ) return;
      this.changerLigne(parseInt(champ.dataset.dfaLigne, 10), parseInt(champ.value, 10) || 0);
    }

    surClic(e) {
      var bouton = e.target.closest('[data-dfa-retirer]');
      if (!bouton) return;
      e.preventDefault();
      this.changerLigne(parseInt(bouton.dataset.dfaRetirer, 10), 0);
    }

    changerLigne(ligne, quantite) {
      var self = this;
      this.setAttribute('aria-busy', 'true');
      fetch((window.dfaRoutes && window.dfaRoutes.cartChange) || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: ligne, quantity: quantite })
      })
        .then(function (r) { return r.json(); })
        .then(function (panier) {
          document.dispatchEvent(new CustomEvent('dfa:cart-updated', { detail: panier }));
          return fetch(window.location.pathname + '?section_id=' + self.sectionId);
        })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neuf = doc.querySelector('dfa-panier');
          if (neuf) self.innerHTML = neuf.innerHTML;
          self.removeAttribute('aria-busy');
        })
        .catch(function () { window.location.reload(); });
    }
  }

  if (!customElements.get('dfa-panier')) customElements.define('dfa-panier', DfaPanier);
})();
